import React from 'react';
import { Avatar, Typography, Skeleton } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import defaultBook from '../Images/defaultBook.png';
import audioIcon from '../Images/icons3.png';
import articleIcon from '../../src/svg/articlesHome.svg';
import { useTranslation } from 'react-i18next';
import HorizontalCardForAud from './HorizontalCardForAud';


interface Item {
  title: string;
  img?: string;
  id?: string;
  videoHash?: string;
  slug?: string;
  [key: string]: any;
}

interface Props {
  title: string;
  items: Item[];
  totalRecords?: number;
  onViewAllClick?: () => void;
  onItemClick?: (id?: string, item?: Item) => void;
  hideImage?: boolean;
  showDailySatsangLogo?: boolean;
  showArticleLogo?: boolean;
  itemType?: string;
  loading?: boolean;
}

const LatestSection: React.FC<Props> = ({ title, items, totalRecords, onViewAllClick, onItemClick, hideImage = false, showDailySatsangLogo = false, showArticleLogo = false, itemType, loading = false }) => {
  const { t } = useTranslation();
  const shouldShowViewAll = totalRecords !== undefined && totalRecords > items.length;

  const myStyles = {
    backgroundColor: "white",
    padding: "8px",
    width: "27vw",
    height: "46vw",
    textAlign: "center",
    flex: "0 0 auto",
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  } as React.CSSProperties;

  const myStyles2 = {
    backgroundColor: "white",
    padding: "20px",
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    width: "50vw",
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  } as React.CSSProperties;
  return (
    <div
      style={{
        backgroundColor: title === "All Books" ? "#FAD5A5" : "white",
        padding: 8,
        margin: 5,
        marginTop: 5,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <p style={{ fontSize: '20px', color: '#C40233', fontWeight: 600, fontFamily: 'chanakyaUni', margin: 0 }}>
          {title}
        </p>
        {shouldShowViewAll && (
          <div
            style={{
              backgroundColor: "#f97316",
              padding: '5px 10px',
              height: 30,
              borderRadius: 3,
              color: "white",
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: 'chanakyaUni',
              cursor: 'pointer',
              marginLeft: '10px',
              fontSize: '14px'
            }}
            onClick={onViewAllClick}
          >
            {t('view_all_tr')} {totalRecords} {itemType} {t('view_all_suffix_tr')}
          </div>
        )}
      </div>

      <div style={{
        display: "flex", gap: "8px", overflowX: "auto",
        marginTop: 10, paddingBottom: "10px", scrollbarWidth: "none", msOverflowStyle: "none"
      }}>
        {loading ? (
          Array.from(new Array(4)).map((_, index) => (
            <div key={index} style={{
              backgroundColor: "white", padding: "8px",
              width: "27vw", height: "46vw", textAlign: "center",
              flex: "0 0 auto", boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'
            }}>
              <Skeleton variant="rectangular" width="21vw" height="30vw" sx={{ borderRadius: '4px' }} />
              <Skeleton variant="text" width="90%" height={14} sx={{ mt: 1 }} />
              <Skeleton variant="text" width="60%" height={14} />
            </div>
          ))
        ) : (
        items?.map((book, index) => (
          <>

            {
              hideImage ? (
                <>

                  <div style={{ display: 'block', width: "100%" }} onClick={(e) => { e.stopPropagation(); onItemClick?.(book.id, book); }}>

                    <img src={book.img || defaultBook} alt={book.title} style={{ borderRadius: "8px", height: "20vw", objectFit: "cover" }}
                      onError={(e) => { e.currentTarget.src = defaultBook; }}
                    />

                    {book.title}
                  </div>
                </>

              ) :

                showDailySatsangLogo ? (
                    <HorizontalCardForAud
                      key={index}
                      title={book.title}
                      onClick={() => onItemClick?.(book.id, book)}
                    />
                ) :

                  showArticleLogo ? (
                    <>

                      <div  key={index} style={{
                        backgroundColor: "white", padding: "8px",
                      width: "27vw", height: "38vw", textAlign: "center",
                      flex: "0 0 auto", boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                      display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'
                    }} onClick={(e) => { e.stopPropagation(); onItemClick?.(book.id, book); }}>

                      <div style={{ display: 'block' }}>

                        <div>

                          <img src={articleIcon} height={60} width={60} />
                          </div>

                          <p style={{
                            fontWeight: "bold", color: "#4b2e2e", fontSize: "13px", marginTop: "4px",
                            display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical",
                            overflow: "hidden", textOverflow: "ellipsis", wordBreak: "break-word", margin: 0
                          }}>

                            {book.title}
                          </p>
                        </div>
                      </div>
                    </>

                  ) :
                    (



                      <div  key={index} style={{
                        backgroundColor: "white", padding: "8px",
                        width: "27vw", height: "46vw", textAlign: "center",
                        flex: "0 0 auto", boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'
                      }} onClick={(e) => { e.stopPropagation(); onItemClick?.(book.id, book); }}>




                        <img src={book.img || defaultBook} alt={book.title} style={{
                          width: "21vw", height: "30vw", objectFit: "cover"
                        }}
                          onError={(e) => { e.currentTarget.src = defaultBook; }}
                        />

                        <p style={{
                          fontWeight: "bold", color: "#4b2e2e", fontSize: "14px", marginTop: "4px",
                          display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical",
                          overflow: "hidden", textOverflow: "ellipsis", wordBreak: "break-word"
                        }}>
                          {book.title}
                        </p>

                      </div>
                    )

            }
          </>
        ))
        )}

        {shouldShowViewAll && (
          <div
            onClick={onViewAllClick}
            style={showDailySatsangLogo || hideImage || showArticleLogo ? myStyles2 : myStyles}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '4px',
                textAlign: 'center',
              }}
            >
              <Avatar sx={{ bgcolor: '#f97316', width: 35, height: 35 }}>
                <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
              </Avatar>
              <Typography className='mt-2' style={{ fontSize: '14px', color: "#f97316" }}>{t('view_all_tr')} {totalRecords} {itemType} {t('view_all_suffix_tr')}</Typography>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LatestSection;


